"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgLogoexamev3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_exame_v3_svg__Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    width: 70,
    viewBox: "0 0 43 43",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("style", null, ".logo_exame_v3_svg__st1{fill:#fff}"), /*#__PURE__*/React.createElement("path", {
    d: "M.5 21.5c0-11.6 9.4-21 21-21 5.6 0 10.9 2.2 14.8 6.2s6.2 9.3 6.2 14.8c0 11.6-9.4 21-21 21s-21-9.4-21-21z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0a6fb8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_exame_v3_svg__st1",
    d: "M28.2 22.2c.2.5.3 1.1.4 1.8.9.2 1.5 1.1 1.3 2s-1.1 1.5-2 1.3-1.5-1.1-1.3-2c.1-.6.6-1.1 1.2-1.2 0-.7-.2-1.8-.9-2.3-.4-.1-.7-.2-1.1-.2 0 1.2-4.2 4.3-4.2 4.3s-4.1-3.1-4.2-4.3c-.4 0-.8.1-1.2.2-.5.4-.8 1.1-.8 2.2.2.1.3.2.3.4.5.3 1 .8 1.4 1.6.1.1.1.3 0 .4.2.5.3 1.1.3 1.7 0 .7 0 1.4-.8 1.6-.1.1-.2.1-.3.1h-.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h.7c.1-.1.1-.5.1-.8 0-.5-.1-1-.3-1.4-.1-.1-.2-.1-.2-.2-.3-.7-.8-1.1-1.1-1.1s-.8.5-1.2 1.2c-.1.1-.1.2-.3.3-.2.4-.3.9-.3 1.3 0 .2 0 .6.1.8h.8c.3 0 .5.2.5.4 0 .3-.2.5-.5.5h-.5c-.1 0-.2 0-.3-.1-.3-.1-.5-.2-.7-.4-.2-.3-.2-.6-.2-1.2s.1-1.1.3-1.7V26c.2-.5.5-.9.8-1.2.2-.2.4-.3.6-.4.1-.2.2-.3.4-.4 0-.7.1-1.3.3-1.8-2.3 1.2-3.8 3.5-3.8 6.1 0 3.4 2.5 3.6 5.8 3.6H26.1c3.3 0 5.8-.2 5.8-3.6.2-2.6-1.3-5-3.7-6.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "logo_exame_v3_svg__st1",
    cx: 28.2,
    cy: 25.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "logo_exame_v3_svg__st1",
    cx: 21.6,
    cy: 16.4,
    r: 5.4
  }));
}
var _default = exports["default"] = SvgLogoexamev3;